/**
 * Type for trigger types supported by Post Office messages.
 * - 'onPageLoad': Message renders immediately when page loads (default behavior)
 * - 'gasV3': Message waits for a GASv3 analytics event before rendering
 * - 'poTrigger': Message waits for a Post Office trigger event before rendering
 * - 'subscription': Message waits for a subscription event before rendering
 */
export type TriggerType = 'onPageLoad' | 'gasV3' | 'poTrigger' | 'subscription';

/**
 * Determines if a message is client-triggered (requires waitForTrigger).
 * Client-triggered messages have triggerType of 'gasV3' or 'poTrigger'.
 *
 * @param triggerType - The trigger type from message context
 * @returns true if the message is client-triggered (gasV3 or poTrigger)
 */
export const isClientTriggeredMessage = (triggerType?: TriggerType): boolean => {
	if (!triggerType) {
		return false;
	}

	return triggerType === 'gasV3' || triggerType === 'poTrigger';
};
